import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const { logo, title, description, linkText, link } = props;

	// Certifique-se de que logos seja sempre tratada como um array
	const logosArray = Array.isArray(logo) ? logo : [logo];

	console.log("Logos received in Project component:", props); // Adicione este console.log

	console.log(logosArray)

	return (
		<React.Fragment>
			<div className="project">
				<Link to={link}>
					<div className="project-container">
						<div className="project-logos">
							{logosArray.map((logo, index) => (
								<img
									key={index}
									src={logo}
									alt={`Logo ${index}`}
									style={{ width: '30px', height: '30px', marginRight: '10px' }} // Adiciona margem direita de 10px
								/>
							))}

						</div>
						<div className="project-title">{title}</div>
						<div className="project-description">{description}</div>
						<div className="project-link">
							<div className="project-link-icon">
								<FontAwesomeIcon icon={faLink} />
							</div>
							<div className="project-link-text">{linkText}</div>
						</div>
					</div>
				</Link>
			</div>
		</React.Fragment>
	);
};

export default Project;
